import { NgModule } from '@angular/core';
import { ButtonsModule } from "./buttons/buttons.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NbCardModule, NbButtonModule, NbIconModule, NbInputModule } from "@nebular/theme";
import { CommonModule } from "@angular/common";
import { ThemeModule } from '../@theme/theme.module';
import { SmartTableElementsModule } from './smart-table-elements/smart-table-elements.module';
import { FormElementsModule } from './forms-elements/form-elements.module';
import { DialogsModule } from './dialogs/dialogs.module';
import { GaugeMeterComponent } from './gauge-meter/gauge-meter.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input'; // Make sure you also import MatInputModule if you're using input within mat-form-field
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DropdownComponentComponent } from './dropdown-component/dropdown-component.component';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';




@NgModule({
  imports: [
    CommonModule,
    ThemeModule,
    NbCardModule,
    NbButtonModule,
    NbIconModule,
    NbInputModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonsModule,
    SmartTableElementsModule,
    FormElementsModule,
    DialogsModule,
    MatFormFieldModule,
    MatInputModule, // Import MatInputModule if you're using input within mat-form-field
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatDialogModule,

  ],
  declarations: [GaugeMeterComponent, AutocompleteComponent, CustomDropdownComponent, DropdownComponentComponent],
  exports: [GaugeMeterComponent],
  bootstrap: [DropdownComponentComponent],
})
export class ComponentsModule { }

